export default "__VITE_ASSET__BqjsaM0___"